import axios from 'axios';

export const SYSTEM_SETTINGS = '/system-settings';

export function getSetting(params) {
  return axios.get(SYSTEM_SETTINGS, { params });
}
